import scrollIntoView from 'smooth-scroll-into-view-if-needed'

export default class SmoothScrollController { // singleton pattern
    #isSmoothScrolling = false;

    constructor() { // pass the appInitializer into parameters
        if (SmoothScrollController.singleton) {
            return SmoothScrollController.singleton
        }
        SmoothScrollController.singleton = this
        return SmoothScrollController.singleton
    }

    get isSmooothScrolling() {
        return this.#isSmoothScrolling
    }

    #ensureAppsInitialized() { // TODO move this method into appInitializer
        return new Promise((resolve, reject)=>{
            if (!window.appInitializer) throw new Error('no app initializer instance found')
            if (!window.appInitializer.isAllAppsInitialized()) {
                window.appInitializer.initAll()
                setTimeout(()=>resolve(), 100) // provide a little delay to render elements and let element hights finalize
            } else {
                resolve()
            }
    
        })
    }

    #setListeners() {
        // not using custom events, since custom evnets aren't supported by freemarker
        window.addEventListener("smoothScrollToTop", ()=>{this.scrollToSelector("#tf-head")}) // i had to leave this and not use "smoothScrollToSelector" because Moris already put "smoothScrollToTop" into the header/footer Migdal block and I dont want to bother him
        window.addEventListener("smoothScrollToSelector", (e)=>{
            if (e.detail.block) {
                this.scrollToSelector(e.detail.selector, e.detail.block)
            } else {
                this.scrollToSelector(e.detail.selector)
            }
        })
    }

    async scrollToSelector(selector, block="start") {
        if (this.#isSmoothScrolling) return
        window.dispatchEvent(new Event("smoothScrollBegin"))
        await this.#ensureAppsInitialized()
        this.#isSmoothScrolling = true
        const element = document.querySelector(selector)
        await scrollIntoView(element, {
            // scrollMode: 'if-needed',
            ease: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
            duration: 750,
            block: block,
            inline: 'nearest',
        })
        this.#isSmoothScrolling = false
        window.dispatchEvent(new Event("smoothScrollEnd"))
    }

    init() {
        this.#setListeners()
    }

}